export default __webpack_public_path__ + "static/media/musicstream.b6ce3c99.png";